import { resumeKeywordCloud, suspendKeywordCloud } from './keywordCloud';

export function suspendInactiveViewKeywordCloud(previousView: HTMLElement | null, nextView: string): void {
	if (previousView?.id === 'view-article' && nextView !== 'article') {
		suspendKeywordCloud(previousView.querySelector<HTMLElement>('#chapter-keyword-cloud'));
	}
	if (previousView?.id === 'view-topic' && nextView !== 'topic') {
		suspendKeywordCloud(previousView.querySelector<HTMLElement>('#topic-keyword-cloud'));
	}
}

export function resumeActiveViewKeywordCloud(view: HTMLElement | null): void {
	if (view?.id === 'view-article') resumeKeywordCloud(view.querySelector<HTMLElement>('#chapter-keyword-cloud'));
	if (view?.id === 'view-topic') resumeKeywordCloud(view.querySelector<HTMLElement>('#topic-keyword-cloud'));
}
